import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Components/Utils/Button";

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Beyond Limits Football Academy";
    setTimeout(() => {
      navigate("/");
    }, [10000]);
  }, [navigate]);
  return (
    <section className="Thank__You" style={{ height: "700px" }}>
      <div className="Thank__you--div container">
        <p className="Thank__you--title">successfully sent</p>
        <p className="Thank__you--text">thank you for your inquiry</p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <Button
            text={"return to the homepage"}
            div={{
              padding: "10px 20px",

              backgroundColor: "#007ebb",
            }}
            link={{
              fontSize: "1.6rem",
              letterSpacing: "2px",
              textTransform: "capitalize",
            }}
            url="/"
          />
        </div>
      </div>
    </section>
  );
}
